module.exports = __webpack_public_path__ + "static/media/Amit.b718a4c9.jpg";